/* eslint-disable max-lines */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { getIconPath, getSFCCClass } from '@tcp/core/src/utils/utils';
import Notification from '@tcp/core/src/components/common/molecules/Notification';
import withStyles from '../../../hoc/withStyles';
import BodyCopy from '../../../atoms/BodyCopy';
import styles from '../styles/CouponCard.style';
import Button from '../../../atoms/Button';
import ErrorMessage from '../../../../features/CnC/common/molecules/ErrorMessage';
import { COUPON_REDEMPTION_TYPE } from '../../../../../services/abstractors/CnC/CartItemTile';
import Image from '../../../atoms/Image';
import CouponHeader from './components/CouponHeader';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblDetails,
} from '../../../../../utils/labels/globalGeneric.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
} from '../../../../../utils/labels/globalActions.labels.js';
import CouponCardLabels, {
  ACCOUNT_LABELS,
  CHECKOUT_LABELS,
  GLOBAL_LABELS,
} from '../labels/CouponCard.labels';

class CouponCard extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.contRef = React.createRef();
    this.checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, CouponCardLabels);
    this.globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, CouponCardLabels);

    this.accountLabel = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, CouponCardLabels);

    this.billing = this.checkoutLabels.billing;
    this.bagPage = this.checkoutLabels.bagPage;

    this.placeRewards = this.globalLabels.placeRewards;
    this.accountDrawer = this.globalLabels.accountDrawer;

    this.accountOverview = this.accountLabel.accountOverview;
  }

  componentDidUpdate(prevProps) {
    const { coupon, handleErrorCoupon } = this.props;
    if (!prevProps.coupon.error && coupon.error) {
      handleErrorCoupon(coupon);
    }
  }

  getCouponLabelValue = ({ coupon, errorBonusPoints, isBonusPointDayEnabled }) => {
    let value = '';
    if (coupon?.isExpired) {
      value = renderLabel(this.billing?.lbl_expired, 'lbl_expired');
    } else if (coupon?.isExpiring) {
      value = renderLabel(this.bagPage?.lbl_couponlist_expiring, 'lbl_couponlist_expiring');
    } else if (errorBonusPoints && isBonusPointDayEnabled) {
      value = renderLabel(this.accountOverview?.lbl_bonus_points_error, 'lbl_bonus_points_error');
    }
    return value;
  };

  calculateEstimatedTotal = (
    subTotal,
    couponsTotal,
    savingsTotal,
    giftCardsItemsTotalPrice,
    giftCardsTotal,
    itemsCount,
    totalPriceOfAllLicensedProducts
  ) => {
    return itemsCount
      ? subTotal -
          couponsTotal -
          savingsTotal -
          giftCardsItemsTotalPrice -
          giftCardsTotal -
          (totalPriceOfAllLicensedProducts || 0)
      : 0;
  };

  getOnHoldLabel = (coupon, estimatedTotal) => {
    if (coupon?.promotionId === 'FreeGiftWrapping') {
      return renderLabel(
        this.bagPage?.lbl_coupon_free_gift_wrapping_on_hold,
        'lbl_coupon_free_gift_wrapping_on_hold'
      );
    }

    if (coupon?.originalOfferType === 'PLCB' || coupon?.originalOfferType === 'PLCC') {
      return renderLabel(this.bagPage?.lbl_coupon_onhold_error, 'lbl_coupon_onhold_error');
    }

    if (
      coupon?.couponValue &&
      (coupon?.originalOfferType === 'LOYALTY' || coupon?.originalOfferType === 'PERKS-LOYALTY')
    ) {
      const thresholdValue = Number(coupon?.couponValue - estimatedTotal) || 0;
      return (
        renderLabel(
          this.bagPage?.lbl_coupon_threshold_onhold_msg,
          'lbl_coupon_threshold_onhold_msg'
        )?.replace('XX', Math.abs(thresholdValue)?.toFixed(2)) || ''
      );
    }

    return renderLabel(
      this.bagPage?.lbl_coupon_generic_onhold_msg,
      'lbl_coupon_generic_onhold_msg'
    );
  };

  getCouponExpiringStatus = (
    coupon,
    couponOnHoldNewDesign,
    isBonusPointDayEnabled,
    errorBonusPoints
  ) => {
    const { ledgerSummaryData, totalPriceOfAllLicensedProducts } = this.props;

    const {
      subTotal = 0,
      couponsTotal = 0,
      savingsTotal = 0,
      giftCardsItemsTotalPrice = 0,
      giftCardsTotal = 0,
      itemsCount = 0,
    } = ledgerSummaryData || {};

    const estimatedTotal = this.calculateEstimatedTotal(
      subTotal,
      couponsTotal,
      savingsTotal,
      giftCardsItemsTotalPrice,
      giftCardsTotal,
      itemsCount,
      totalPriceOfAllLicensedProducts
    );

    let value = this.getCouponLabelValue({ coupon, errorBonusPoints, isBonusPointDayEnabled });

    if (couponOnHoldNewDesign && coupon?.isOnHold === 'true') {
      value = this.getOnHoldLabel(coupon, estimatedTotal);
    }

    if (!coupon?.isStarted) {
      value = getDynamicLabelValues('dynamic.cart.lbl_coupon_placeCash_Redemption');
    }

    return value?.replace('!', '');
  };

  isPlacePerksCoupon = () => {
    const { coupon } = this.props;
    return coupon.offerType === COUPON_REDEMPTION_TYPE.PLACEPERKS;
  };

  isAutoApplyPerkCoupon = () => {
    const { coupon = {}, autoApplyPerkCouponType = '' } = this.props;
    const { originalOfferType = '', couponType = '' } = coupon;
    return (
      originalOfferType === 'PERKS-IMPLICIT' ||
      (autoApplyPerkCouponType !== '' &&
        couponType &&
        autoApplyPerkCouponType?.includes(couponType))
    );
  };

  titleTooltip = () => {
    const { coupon } = this.props;
    return this.isPlacePerksCoupon() ? coupon.title : '';
  };

  renderAlwaysAppliedStatus = (coupon) => {
    return (
      <BodyCopy className="coupon_footer_wrapper">
        <BodyCopy
          data-locator={`coupon_${coupon.status}_footer_expired`}
          className="couponCard_applied_footer_expired"
          component="div"
          fontSize="fs12"
          fontFamily="secondary"
          fontWeight="extrabold"
        >
          <Image alt="profile" className="link-icon" src={getIconPath('circle-check-fill-green')} />{' '}
          {getDynamicLabelValues('dynamic.account_d.lbl_perk_status_always_applied')?.replace(
            '!',
            ''
          )}
        </BodyCopy>
      </BodyCopy>
    );
  };

  getCouponVerifyCond = ({ isCarouselView, coupon, couponOnHoldNewDesign }) => {
    return (
      !isCarouselView ||
      (isCarouselView && coupon?.status !== 'applied') ||
      (couponOnHoldNewDesign && coupon?.isOnHold === 'true')
    );
  };

  getCouponFooterCond = ({
    coupon,
    isBonusPointDayEnabled,
    errorBonusPoints,
    couponOnHoldNewDesign,
  }) => {
    return (
      coupon.isExpiring ||
      !coupon?.isStarted ||
      coupon?.isExpired ||
      (coupon?.isBPDBlackoutDay && !coupon?.usedBPD && isBonusPointDayEnabled) ||
      errorBonusPoints ||
      (couponOnHoldNewDesign && coupon?.isOnHold === 'true') ||
      coupon?.isLoyaltyBPDBlackoutDay
    );
  };

  checkErrorBounsPoint = ({ coupon }) => {
    const unavailableToday = coupon?.fromBonusPointsDay && coupon?.availableToday === 0;

    return (
      (coupon?.isApplied && coupon?.fromBonusPointsDay && coupon?.status === 'available') ||
      unavailableToday
    );
  };

  RenderStatus = (coupon) => {
    const { isCarouselView, spc, spcBag, couponOnHoldNewDesign, isBonusPointDayEnabled } =
      this.props;
    const couponVerify = this.getCouponVerifyCond({
      isCarouselView,
      coupon,
      couponOnHoldNewDesign,
    });

    if (this.isAutoApplyPerkCoupon()) {
      return this.renderAlwaysAppliedStatus(coupon);
    }

    function getTodayDate() {
      const today = new Date();
      const year = String(today?.getFullYear())?.slice(-2);
      const month = String(today?.getMonth() + 1)?.padStart(2, '0');
      const day = String(today?.getDate())?.padStart(2, '0');

      return `${month}/${day}/${year}`;
    }
    const currentDate = getTodayDate();
    const errorBonusPoints = this.checkErrorBounsPoint({ coupon });

    return (
      (coupon.error && (
        <BodyCopy className="coupon_footer_wrapper">
          <BodyCopy
            data-locator={`coupon_${coupon.status}_footer_expired`}
            className="couponCard_error_footer_expired"
            component="div"
            fontSize="fs12"
            fontFamily="secondary"
            fontWeight="extrabold"
          >
            {coupon?.offerType !== COUPON_REDEMPTION_TYPE?.PLACECASH ? (
              <>
                <Image
                  alt="profile"
                  className="link-icon"
                  src={getIconPath('circle-alert-fill-red')}
                />
                {coupon?.error}
              </>
            ) : (
              <ErrorMessage
                fontSize="fs12"
                fontWeight="extrabold"
                error={coupon?.error}
                icon="circle-info-red"
                noBackground={true}
                isEspot={coupon?.offerType === COUPON_REDEMPTION_TYPE?.PLACECASH}
              />
            )}
          </BodyCopy>
        </BodyCopy>
      )) ||
      (coupon.isCouponApplicable === false && (spc || spcBag) && (
        <BodyCopy className="coupon_footer_wrapper">
          <BodyCopy
            data-locator={`coupon_${coupon.status}_footer_expired`}
            className="couponCard_error_footer_expired"
            component="div"
            fontSize="fs12"
            fontFamily="secondary"
            fontWeight="extrabold"
          >
            <Image
              alt="profile"
              className="link-icon"
              src={getIconPath('circle-alert-fill-yellow')}
            />{' '}
            {coupon.isCouponApplicable === false && coupon.mobileCouponError}
          </BodyCopy>
        </BodyCopy>
      )) ||
      (this.getCouponFooterCond({
        coupon,
        isBonusPointDayEnabled,
        errorBonusPoints,
        couponOnHoldNewDesign,
      }) &&
        couponVerify && (
          <BodyCopy className="coupon_footer_wrapper">
            <BodyCopy
              data-locator={`coupon_${coupon.status}_footer_expired`}
              className="couponCard__footer_expired"
              component="div"
              fontSize="fs12"
              fontFamily="secondary"
              fontWeight="extrabold"
            >
              <Image
                alt="profile"
                className="link-icon"
                src={getIconPath('circle-alert-fill-yellow')}
              />{' '}
              {(coupon?.isBPDBlackoutDay && isBonusPointDayEnabled) ||
              coupon?.isLoyaltyBPDBlackoutDay
                ? `${renderLabel(
                    this.accountOverview?.lbl_bonus_points_black_out_day_warning,
                    'lbl_bonus_points_black_out_day_warning'
                  )} ${currentDate}`
                : this.getCouponExpiringStatus(
                    coupon,
                    couponOnHoldNewDesign,
                    isBonusPointDayEnabled,
                    errorBonusPoints
                  )}
            </BodyCopy>
          </BodyCopy>
        )) ||
      (isCarouselView && coupon?.status === 'applied' && (
        <BodyCopy className="coupon_footer_wrapper">
          <BodyCopy
            data-locator={`coupon_${coupon.status}_footer_expired`}
            className="couponCard_applied_footer_expired"
            component="div"
            fontSize="fs12"
            fontFamily="secondary"
            fontWeight="extrabold"
          >
            <Image
              alt="profile"
              className="link-icon"
              src={getIconPath('circle-check-fill-green')}
            />{' '}
            {renderLabel(this.placeRewards?.lbl_my_rewards_applied, 'lbl_my_rewards_applied')
              ?.toLowerCase()
              ?.replace('!', '')}
          </BodyCopy>
        </BodyCopy>
      ))
    );
  };

  checkApplyCTADisabled = ({
    isFetching,
    coupon,
    isBonusPointDayEnabled,
    multiAddCouponLoader,
  }) => {
    return (
      isFetching ||
      coupon?.isBPDBlackoutDay ||
      (coupon?.isApplied && coupon?.fromBonusPointsDay && isBonusPointDayEnabled) ||
      (coupon?.fromBonusPointsDay && coupon?.availableToday === 0) ||
      multiAddCouponLoader ||
      coupon?.isLoyaltyBPDBlackoutDay
    );
  };

  RenderApplyButton = (globalActionLabels) => {
    const {
      coupon,
      onApply,
      isFetching,
      isAccountDrawer,
      isAccountDashboard,
      isPlacePerkEnabled,
      isPlacePerks,
      isCartPageCouponSection,
      isBonusPointDayEnabled,
      setBonusPointDayCouponIndexAction,
      fromIsApplyAction,
      multiAddCouponLoader,
    } = this.props;
    const hideButtonClassName =
      this.isPlacePerksCoupon() && this.isAutoApplyPerkCoupon() ? 'hide-button' : '';
    const couponStatusLower = coupon?.labelStatus ? coupon.labelStatus.toLowerCase() : '';
    return (
      <Button
        onClick={() => {
          setTimeout(() => {
            onApply({ coupon });
            fromIsApplyAction(true);
            if (isBonusPointDayEnabled && coupon?.fromBonusPointsDay) {
              setBonusPointDayCouponIndexAction(coupon?.couponIndex);
            }
          }, 0);
        }}
        className={
          isAccountDrawer || isAccountDashboard || (isPlacePerkEnabled && isPlacePerks)
            ? `coupon__button_white ${hideButtonClassName}`
            : `coupon__button_black ${hideButtonClassName}`
        }
        buttonVariation="variable-width"
        type="submit"
        data-locator={`coupon_${coupon.status}_apply_cartCta`}
        fullWidth="true"
        disabled={this.checkApplyCTADisabled({
          isFetching,
          coupon,
          isBonusPointDayEnabled,
          multiAddCouponLoader,
        })}
        aria-labelledby={coupon.id}
      >
        {globalActionLabels[`lbl_${couponStatusLower}`] || coupon.labelStatus}
        {!isCartPageCouponSection && ' '}
        {isPlacePerkEnabled ||
          ((isAccountDrawer || isAccountDashboard) &&
            !isCartPageCouponSection &&
            coupon?.labelStatus !== 'applied' &&
            `${renderLabel(this.accountDrawer?.lbl_couponCard_now, 'lbl_couponCard_now')}`)}
      </Button>
    );
  };

  RenderRemoveButton = (globalActionLabels) => {
    const { coupon, onRemove, fromIsApplyAction } = this.props;
    const couponStatusLower = coupon?.labelStatus ? coupon.labelStatus.toLowerCase() : '';
    return (
      <Button
        onClick={(e) => {
          e.preventDefault();
          onRemove({ coupon });
          fromIsApplyAction(true);
        }}
        className="coupon__button_white"
        buttonVariation="variable-width"
        type="submit"
        data-locator={`coupon_${coupon.status}_remove_cartCta`}
        fullWidth="true"
        aria-label={`${coupon.labelStatus} ${coupon.id}`}
      >
        {globalActionLabels[`lbl_${couponStatusLower}`] || coupon.labelStatus}
      </Button>
    );
  };

  RenderValidText = (coupon) => {
    return (
      <BodyCopy
        className="couponCard__text_style"
        component="p"
        fontSize="fs10"
        data-locator={`coupon_${coupon.status}_cartValidValidity`}
        fontFamily="secondary"
      >
        {`Valid ${coupon.effectiveDate} - ${coupon.expirationDate}`}
      </BodyCopy>
    );
  };

  RenderUseByText = (coupon) => {
    return (
      <BodyCopy
        className="couponCard__text_style"
        data-locator={`coupon_${coupon.status}_cartUseByValidity`}
        component="p"
        fontSize="fs10"
        fontFamily="secondary"
      >
        {`${renderLabel(this.bagPage?.lbl_coupon_validThru, 'lbl_coupon_validThru')} ${
          coupon.expirationDate
        }`}
      </BodyCopy>
    );
  };

  renderCouponText = (coupon) => {
    const { offerType } = coupon;

    if (
      offerType === COUPON_REDEMPTION_TYPE.SAVING ||
      offerType === COUPON_REDEMPTION_TYPE.REWARDS ||
      offerType === COUPON_REDEMPTION_TYPE.BENEFITS ||
      this.isPlacePerksCoupon()
    ) {
      return this.RenderUseByText(coupon);
    }

    if (
      offerType === COUPON_REDEMPTION_TYPE.PLACECASH ||
      offerType === COUPON_REDEMPTION_TYPE.BONUSPOINTDAY
    ) {
      return this.RenderValidText(coupon);
    }

    return null;
  };

  RenderButtons = (coupon) => {
    const { isAccountDrawer, isAccountDashboard, isPlacePerkEnabled, isPlacePerks } = this.props;
    const newButtonClass =
      isAccountDrawer || isAccountDashboard || (isPlacePerkEnabled && isPlacePerks)
        ? 'button-col'
        : '';
    const globalActionLabels =
      getLabelFromCopyOrFromTranslation(GLOBAL_ACTIONS_LABELS, GlobalActionsLabels) || {};
    return (
      <div className={`couponCard__col ${newButtonClass}`}>
        {coupon.isOnHold !== 'true' &&
          coupon.status === 'available' &&
          coupon.isStarted &&
          !(coupon?.isExpired && coupon.status === 'applied') &&
          this.RenderApplyButton(globalActionLabels)}
        {coupon.isOnHold !== 'true' &&
          coupon.status === 'applied' &&
          !coupon?.isExpired &&
          this.RenderRemoveButton(globalActionLabels)}
        {(coupon.isOnHold === 'true' || (coupon?.isExpired && coupon.status === 'applied')) &&
          this.RenderRemoveButton(globalActionLabels)}
      </div>
    );
  };

  handleDefaultLinkClick = (event) => {
    event.preventDefault();
    setTimeout(() => {
      const { coupon, couponDetailClick } = this.props;
      couponDetailClick(coupon);
    }, 0);
  };

  verifySpcCheckCoupons = (isCarouselView, spc) => {
    return !isCarouselView && !spc;
  };

  errorNotificatons = () => {
    const { coupon, couponsOnHold } = this.props;

    return (
      <>
        {couponsOnHold && (
          <Notification
            className="max-qty-reached elem-mt-MED"
            status="warning"
            isErrorTriangleIcon
            message={
              coupon.originalOfferType === 'PLCB'
                ? renderLabel(this.bagPage?.lbl_coupon_onhold_error, 'lbl_coupon_onhold_error')
                : renderLabel(
                    this.bagPage?.lbl_coupon_apple_onhold_error,
                    'lbl_coupon_apple_onhold_error'
                  )
            }
          />
        )}
      </>
    );
  };

  render() {
    const {
      coupon,
      className,
      isCarouselView,
      spc,
      spcBag,
      isAccountDrawer,
      commonLabels,
      isAccountDashboard,
      isPlacePerkEnabled,
      isPlacePerks,
      currentPerkLevel,
      isWallet,
      isCartPageCouponSection,
    } = this.props;
    const containerOveride = isCarouselView ? 'couponCard_slick' : '';
    const cardWidth = this.contRef?.current?.offsetWidth;
    const cardHeight = this.contRef?.current?.offsetHeight;
    return (
      <div className={className}>
        <div className={`couponCard__container ${containerOveride} ${getSFCCClass(spcBag)}`}>
          {this.verifySpcCheckCoupons(isCarouselView, spc) && (
            <ErrorMessage
              fontSize="fs12"
              fontWeight="extrabold"
              error={coupon.error}
              icon="circle-info-red"
              noBackground={spcBag}
              isEspot={coupon.offerType === COUPON_REDEMPTION_TYPE.PLACECASH}
            />
          )}
          <div
            ref={this.contRef}
            className="couponCard__container_main rounded-container"
            id="card-container"
          >
            {(coupon.labelStatus === 'applying' || coupon.labelStatus === 'removing') && (
              <div
                style={{ width: cardWidth, height: cardHeight }}
                className="couponCard__container_loader"
              />
            )}
            <CouponHeader
              coupon={coupon}
              isCarouselView={isCarouselView}
              commonLabels={commonLabels}
              spcBag={spcBag}
              spc={spc}
              isAccountDrawer={isAccountDrawer}
              isAccountDashboard={isAccountDashboard}
              isPlacePerkEnabled={isPlacePerkEnabled}
              isPlacePerks={isPlacePerks}
              currentPerkLevel={currentPerkLevel}
              isWallet={isWallet}
              isCartPageCouponSection={isCartPageCouponSection}
            />

            <div className="couponCard__body">
              <div className="couponCard__row">
                <div className="couponCard__col">
                  <BodyCopy
                    className={`elem-pr-SM ${spc ? 'couponSpc__content' : ''}`}
                    component="div"
                    color="text.primary"
                  >
                    <BodyCopy
                      component="p"
                      fontSize="fs12"
                      lineHeight="lh115"
                      fontWeight="black"
                      fontFamily="secondary"
                      className="couponTitle"
                      data-locator={`coupon_${coupon.status}_couponNameLbl`}
                      id={coupon.id}
                      title={this.titleTooltip()}
                      ref={this.myRef}
                    >
                      {`${coupon.title}`}
                    </BodyCopy>
                    {this.renderCouponText(coupon)}
                  </BodyCopy>
                  <Button
                    dataLocator={`coupon_${coupon.status}_cartDetailsLink`}
                    fontSizeVariation="small"
                    underline
                    anchorVariation="primary"
                    nohover
                    type="button"
                    link
                    onClick={this.handleDefaultLinkClick}
                    className="cartDetailsLink"
                    aria-label={`${coupon.id} ${renderLabel(
                      getLabelFromCopyOrFromTranslation(
                        `${GLOBAL_GENERIC_LABELS}.${lblDetails}`,
                        GlobalGenericLabels
                      ),
                      'lbl_details'
                    )}`}
                  >
                    {renderLabel(
                      getLabelFromCopyOrFromTranslation(
                        `${GLOBAL_GENERIC_LABELS}.${lblDetails}`,
                        GlobalGenericLabels
                      ),
                      'lbl_details'
                    )}
                  </Button>
                </div>
                {!coupon.usedBPD && this.RenderButtons(coupon)}
              </div>
            </div>
          </div>
          {this.errorNotificatons()}
          {(isAccountDrawer ||
            isAccountDashboard ||
            (isPlacePerkEnabled && isPlacePerks) ||
            (this.isPlacePerksCoupon() && this.isAutoApplyPerkCoupon())) &&
            this.RenderStatus(coupon)}
        </div>
      </div>
    );
  }
}

CouponCard.defaultProps = {
  couponsOnHold: false,
  spc: false,
  spcBag: false,
  isAccountDrawer: false,
  isPlacePerkEnabled: false,
  isPlacePerks: false,
  autoApplyPerkCouponType: '',
};

CouponCard.propTypes = {
  coupon: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  handleErrorCoupon: PropTypes.func.isRequired,
  isCarouselView: PropTypes.bool.isRequired,
  commonLabels: PropTypes.shape({}).isRequired,
  onApply: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  couponDetailClick: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  couponsOnHold: PropTypes.bool,
  spc: PropTypes.bool,
  spcBag: PropTypes.bool,
  isAccountDrawer: PropTypes.bool,
  isPlacePerkEnabled: PropTypes.bool,
  isPlacePerks: PropTypes.bool,
  autoApplyPerkCouponType: PropTypes.string,
};

export default withStyles(CouponCard, styles);
export { CouponCard as CouponCardVanilla };
